var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-container"},[_c('div',{staticClass:"left-wrapper"},[_c('side-bar')],1),_c('div',{staticClass:"right-wrapper"},[_c('layout-header'),_c('div',{staticClass:"layout-content"},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }